// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__ZEmIu","inactiveItemClassName":"Breadcrumb_inactiveItemClassName__Lh_H_"};